module.exports = __webpack_public_path__ + "static/media/no_user_photo.6ed75766.png";